/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Placesused1Inputs */

const en_placesused1 = /** @type {(inputs: Placesused1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.max} Places used`)
};

const de_placesused1 = /** @type {(inputs: Placesused1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} von ${i?.max} Orte verwendet`)
};

/**
* | output |
* | --- |
* | "{used} of {max} Places used" |
*
* @param {Placesused1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placesused1 = /** @type {((inputs: Placesused1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placesused1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placesused1(inputs)
	return de_placesused1(inputs)
});
export { placesused1 as "placesUsed" }